import { Sparkle } from "lucide-react";

const ITEMS = [
  "RICONOSCERE LE EMOZIONI",
  "ESPRIMERE CON CREATIVITÀ",
  "CRESCERE SERENI",
  "20 ATTIVITÀ CREATIVE",
  "DAI 6 AGLI 11 ANNI",
  "DIARIO DELLE EMOZIONI",
  "CERTIFICATO FINALE",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-olive/20 bg-olive py-4" data-testid="editorial-marquee" aria-hidden>
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-8 pr-8 font-editorial text-lg italic tracking-wide text-cream/90 sm:text-xl">
                {item}
                <Sparkle className="h-4 w-4 shrink-0 text-amazon-orange" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
